import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useAppSelector } from '../../../../../../app/hooks'
import { fetchDirectory } from '../../../../../../features/phone/phoneThunk'
import { DirectoryContact } from '../../../../../../shared/types'

const useDirectory = () => {
  const dispatch = useDispatch()

  const { data, loading, error } = useAppSelector(
    (state) =>
      state.phone?.directory || {
        data: [],
        loading: false,
        error: null,
      }
  )

  useEffect(() => {
    dispatch(fetchDirectory())
  }, [dispatch])

  return {
    contacts: data as DirectoryContact[],
    loading,
    error,
  }
}

export default useDirectory
